// libs
import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';

// components
import ChargebackPage from './ChargebackPage';
import ChargebackDetails from './ChargebackDetails';
import DisputeDetails from './DisputeDetails';


// styles
import './chargeback.scss';

const Chargeback = props => {
    return (
        <div className="chargeback-wrapper">
            <Switch>
                <Route exact path="/chargeback">
                    <ChargebackPage />
                </Route>
                <Route path="/chargeback/dispute/:chargebackId/:orderId/:type">
                   <DisputeDetails />
                </Route>
                <Route path="/chargeback/:chargebackId/:orderId/:type">
                    <ChargebackDetails />
                </Route>
            </Switch>
        </div>
    );
};

// PropType validation for Chargeback component
Chargeback.propTypes = {
    actions: PropTypes.object,
};

export default Chargeback;
